<template>
  <v-container v-if="hasPrivilege()">
    <v-layout>
      <v-flex sm4 class="mt-2">
        <h2>Team Management</h2>
      </v-flex>
      <v-flex sm4 offset-sm4 class="text-xs-right">
        <AddTeamDialog
          @result="showMessage"
          :eligible="teams.length <= maximumNumberOfTeam()"
          :maximumNumberOfTeamMembers="maximumNumberOfTeamMembers()"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm4 offset-sm8>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <v-data-table
      :headers="headers"
      :items="teams"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.team_name }}</td>
        <td class="text-xs-center">{{ props.item.team_code }}</td>
        <td class="text-xs-right">
          <span title="Available">{{ props.item.team_response_count }}</span>
          |
          <span title="Max Members">{{ props.item.numbers_of_dasher }}</span>
        </td>
        <td class="text-xs-center" style="min-width: 120px">
          <div class="actions">
            <ViewTeamDialog :teamDetails="props.item" />
            <EditTeamDialog
              :teamDetails="props.item"
              :maximumNumberOfTeamMembers="maximumNumberOfTeamMembers()"
              @result="showMessage"
            />
          </div>
        </td>
      </template>
      <template v-slot:pageText="props">
        Teams {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ message }}
    </v-snackbar>
  </v-container>
  <v-container v-else>
    <v-layout>
      <v-flex sm4 class="mt-2">
        <h2>Team Management</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <h3>You are not allowed to create team.  </h3>
        <p>Please upgrade your subscription to premium or corporate package</p>
                <br />
                <router-link to="/subscription-package"
                  ><p>click here to go to subscription page</p></router-link
                >
      </v-flex>
    </v-layout>
    
  </v-container>
</template>
<script>
import api from "../api/datadash";
import { mapState } from "vuex";
import ViewTeamDialog from "../components/team/ViewTeamDialog.vue";
import AddTeamDialog from "../components/team/AddTeamDialog.vue";
import EditTeamDialog from "../components/team/EditTeamDialog.vue";
import utilities from "../api/utilities";
export default {
  components: { ViewTeamDialog, AddTeamDialog, EditTeamDialog },
  data() {
    return {
      loading: false,
      search: "",
      headers: [
        {
          text: "#",
          value: "id",
          align: "right",
        },
        { text: "Name", value: "team_name", align: "center" },
        { text: "Code", value: "team_code", align: "center" },
        { text: "Members", value: "numbers_of_dasher", align: "right" },
        { text: "Action", sortable: false, align: "center" },
      ],
      teams: [],
      color: "",
      message: "",
      snackbar: false,
    };
  },
  computed: {
    ...mapState(["auth", "application"]),
  },
  created() {
    this.fetchTeams();
  },
  methods: {
    async fetchTeams() {
      this.loading = true;
      try {
        const { data } = await api.fetchData(this.auth.token, "team");
        this.teams = data.data.teams;
      } catch (e) {
        // console.log(e);
      }
      this.loading = false;
    },
    showMessage(event) {
      this.color = event[1];
      this.message = event[0];
      this.snackbar = true;
      if (this.color == "success") {
        this.fetchTeams();
      }
    },
    maximumNumberOfTeam() {
      return utilities.maximumNumberOfTeam(
        this.application.subscriptionData.subscriptionFeatures
      );
    },
    maximumNumberOfTeamMembers() {
      return utilities.maximumNumberOfTeamMembers(
        this.application.subscriptionData.subscriptionFeatures
      );
    },
    hasPrivilege() {
      if (!this.application.subscriptionData) {
        return false;
      } else if (
        this.application.subscriptionData.subscriptionPlan.package_id < 2
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.actions {
  display: none;
}
tr:hover td > .actions {
  display: block;
}
</style>
